import { createApp, h } from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'

// Parche para evitar crash por ResizeObserver
const ignoreResizeObserverError = (e) => {
  const msg = e.message || (e.reason && e.reason.message) || String(e.error || e)
  if (
    msg &&
    (msg.includes('ResizeObserver loop completed with undelivered notifications') ||
      msg.includes('ResizeObserver loop'))
  ) {
    // Evita que detenga la ejecución
    if (e.stopImmediatePropagation) e.stopImmediatePropagation()
    if (e.preventDefault) e.preventDefault()
    return false
  }
}

// Múltiples estrategias para capturar el error
window.addEventListener('error', ignoreResizeObserverError, true)
window.addEventListener('unhandledrejection', ignoreResizeObserverError, true)

// Override del ResizeObserver para evitar que lance errores
const originalResizeObserver = window.ResizeObserver
window.ResizeObserver = class extends originalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer)
        } catch (e) {
          if (!String(e).includes('ResizeObserver loop')) {
            throw e
          }
        }
      })
    })
  }
}

import './assets/styles.css'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'

import { LoadingPlugin } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

import { waitConfig } from '@/config/api'
import cargarMensajes from './plugins/i18n'

import funcionesWC from '@/plugins/funcionesWC'
import moment from 'moment'
import { customIcons } from '@/plugins/customIcons'

// --- Vuetify Setup ---
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi', // 🔥 Default sigue siendo Material Design
    sets: {
      mdi,
      custom: {
        component: (props) => {
          const icon = customIcons[props.icon]
          if (typeof icon === 'string') {
            return h('img', {
              src: icon,
              alt: props.icon,
              style: { width: '24px', height: '24px', objectFit: 'contain' },
            })
          }
          return h(icon)
        },
      },
    },
  },
  theme: {
    fontFamily: 'Montserrat',
  },
  lang: {
    current: 'es',
  },
})

moment.locale('es')

await waitConfig() // ← clave
const i18n = await cargarMensajes() // ahora sí puede pedir dictionar

// --- App creation ---
const app = createApp(App)
app.use(i18n)
app.use(funcionesWC)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(LoadingPlugin)
app.use(vuetify)
app.provide('icons', icons)
app.component('CIcon', CIcon)

app.config.globalProperties.$toast = toast
app.config.globalProperties.$moment = moment
app.config.globalProperties.$versionGlobal = '1.1.2.61'

// Suprimir errores de ResizeObserver en Vue
app.config.errorHandler = (err, instance, info) => {
  if (err.message && err.message.includes('ResizeObserver loop completed')) {
    return // Ignorar este error específico
  }
  console.error('Error capturado por Vue:', err, info)
}

app.mount('#app')
